import { renderDrawerFooter_unstable } from '@fluentui/react-drawer';

/**
 * Renders the final JSX of the DrawerFooter component, given the state.
 */
export const renderDrawerFooter = renderDrawerFooter_unstable;
